import React, { useRef, useState, useEffect } from "react"
import "../assets/css/Map.css";
import "../assets/css/Popup.css";
import MapContext from "./MapContext";
import * as ol from "ol";
import Overlay from 'ol/Overlay';
//import RechercheLocalisation from "../composants/RechercheLocalisation";
import GestionAffichageCouches from "../composants/GestionAffichageCouches";
import FenetreDescription from "../composants/FenetreDescription";


const Map = ({ children, zoom, center, setCenter, setCentreAdresse,setMapInstance }) => {
	const mapRef = useRef();
	const [map, setMap] = useState(null);
	const [afficherfenetre, setAfficherFenetre] = useState(false);
	const [descriptionpoints, setDescriptionPoints] = useState({});
	const mousein = useRef(false);



	// on component mount
	useEffect(() => {

		var overlayvisualisation = new Overlay({
			element: document.querySelector(`#popup-ajout`),
			autoPan: true,
			positioning: 'top-center',
			autoPanAnimation: {
				duration: 250,
			},
		});

		let options = {
			view: new ol.View({ 
				maxZoom:20,
				minZoom:5,
				center: [593795, 5362134],
				zoom: 11,
			 }),
			
			layers: [],
			controls: [],
			overlays: [overlayvisualisation]
		};

		let mapObject = new ol.Map(options);
		mapObject.setTarget(mapRef.current);


		mapObject.on('singleclick', function (evt) {

			let feature = mapObject.forEachFeatureAtPixel(evt.pixel, function(feature, layer) {
				return feature;
			});

			if (feature) {
				setDescriptionPoints(feature.getProperties())
				setAfficherFenetre(!afficherfenetre);
			}		
		});

		// mapObject.getView().fit([588193,5355067,600572 ,5369062], 1);
		setMap(mapObject);
		setMapInstance(mapObject)
		return () => mapObject.setTarget(undefined);
		// eslint-disable-next-line
	}, []);


	// // zoom change handler
	// useEffect(() => {
	// 	if (!map) return;

	// 	map.getView().setZoom(zoom);
	// 	// eslint-disable-next-line
	// }, [zoom]);

	// // center change handler
	// useEffect(() => {
	// 	if (!map) return;

	// 	map.getView().setCenter(center)
	// 	// eslint-disable-next-line
	// }, [center])


	return (
		<MapContext.Provider value={{ map }}>
			{/*<RechercheLocalisation map={map} center={center} setCenter={setCenter} setCentreAdresse={setCentreAdresse} />*/}
			<div ref={mapRef} className="ol-map">
			<FenetreDescription
				afficher={afficherfenetre}
				setAfficherFenetre={setAfficherFenetre}
				descriptionpoints={descriptionpoints}
			/>
				{children}
	
			</div>
			<GestionAffichageCouches />
		</MapContext.Provider>
	)
}

export default Map;